import React from 'react'

import { Box } from 'widgets/Box'
import { Pressable } from 'widgets/Pressable'
import { Text } from 'widgets/Text'

import commonStyles from 'utils/styles/commonStyles'

type ProgramQuestionRowProps = {
  text: string
  isSelected: boolean
  onPress: () => void
}

export const ProgramQuestionRow = ({ text, isSelected, onPress }: ProgramQuestionRowProps) => {
  return (
    <Pressable onPress={onPress} style={commonStyles.fullWidth}>
      <Box
        height={44}
        borderRadius='sm'
        justifyContent='center'
        backgroundColor={isSelected ? 'v2primary' : 'greyLight'}
        padding={{ horizontal: 'md' }}
        margin={{ top: 'smd', horizontal: 'sm' }}
      >
        <Text
          fontSize='sm'
          color={isSelected ? 'white' : 'v2black'}
          numberOfLines={1}
          bold={isSelected}
        >
          {text}
        </Text>
      </Box>
    </Pressable>
  )
}
